module.exports = __webpack_public_path__ + "static/media/gryphon-house-amenity-dining.d6302703.jpg";